import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const paymentService = { refillWithLiqpay, setPaymentStatusLiqpay };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

/*
serviceOrderTypeId
10 Поповнення рахунку
20 Зміна тарифу
30 Додаткові доставки
40 Оплата підписки модуля
*/
async function refillWithLiqpay(
  amount: number,
  resultUrl: string,
  deliveryCount: number,
  serviceOrderTypeId: number,
  userTariffPlanRequestCode: string,
  moduleTariffId: number | null = null,
  discountCode: string | null = null) {
  return axios.put(model.baseUrl + 'payment/liqpay/refill',
    { amount, resultUrl, deliveryCount, serviceOrderTypeId, userTariffPlanRequestCode, moduleTariffId, discountCode }
  ).then(extract);
}

async function setPaymentStatusLiqpay(data: string, signature: string) {
  const params = new URLSearchParams();
  params.append('data', data);
  params.append('signature', signature);

  return axios
    .post(model.baseUrl + 'payment/liqpay/status', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then(extract);
}
